import React from 'react'
import LuxPlusInclusions from 'luxPlus/components/LuxPlusInclusions'

interface Props {
  luxPlusInclusions: Array<App.PackageInclusion>;
  offer: App.CruiseOffer;
}

function CruiseLuxPlusInclusionList({ luxPlusInclusions, offer }: Props) {
  return <>
    {!!luxPlusInclusions.length && <LuxPlusInclusions
      luxPlusInclusions={luxPlusInclusions}
      showMinStayDescription
      isModalPrimaryActionHidden
      accommodationOffer={offer}
    />}
  </>
}

export default CruiseLuxPlusInclusionList
